import React from 'react';

const DisplayContactCounts = ({ validContacts, invalidContacts, duplicateEmailContacts }) => {
  return (
    <div className="flex flex-col m-2">
      <div className="text-center rounded-lg">
        <div className="flex items-center justify-center gap-2 mb-4">
          <h1 className="text-2xl font-bold text-hs-orange">Filter Summary</h1>
          {typeof window !== 'undefined' && window.setIsSummaryHelpOpen && (
            <button
              type="button"
              onClick={() => window.setIsSummaryHelpOpen(true)}
              className="h-7 w-7 flex items-center justify-center rounded-full bg-gray-700 text-white hover:bg-gray-600"
              aria-label="How is this summary calculated?"
              title="How is this summary calculated?"
            >
              ?
            </button>
          )}
        </div>
        <div className="flex justify-center space-x-4">
          <div className="flex flex-row gap-2 justify-center items-center bg-green-100 text-green-600 p-4 rounded-lg">
            <p className="text-2xl rounded-md bg-white px-4 py-2">{validContacts?.length || 0}</p>
            <h2 className="text-xl font-semibold">Valid Contacts</h2>
          </div>
          <div className="flex flex-row gap-2 justify-center items-center bg-red-100 text-red-500 p-4 rounded-lg">
            <p className="text-2xl rounded-md bg-white px-4 py-2">{invalidContacts?.length || 0}</p>
            <h2 className="text-xl font-semibold">Invalid Contacts</h2>
          </div>
          <div className="flex flex-row gap-2 justify-center items-center bg-yellow-100 text-yellow-600 p-4 rounded-lg">
            <p className="text-2xl rounded-md bg-white px-4 py-2">{duplicateEmailContacts?.length || 0}</p>
            <h2 className="text-xl font-semibold">Duplicate Emails</h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisplayContactCounts;